<template>
    <base-alert
        v-if="has_error"
        level="danger"
    >
        <template slot="heading">{{ message }}</template>

        <template slot="content">{{ detail }}</template>
    </base-alert>
</template>

<script>
    import _ from 'lodash'
    import BaseAlert from './base-alert'

    export default {
        components: {
            BaseAlert
        },
        props: {
            sid: {
                type: [String, Array],
                required: true
            }
        },
        computed: {
            has_error () {
                return !!this.message
            },
            message () {
                return this.dry(sid => this.$validator.message(sid))
            },
            detail () {
                return this.dry(sid => this.$validator.detail(sid))
            }
        },
        methods: {
            dry (callback) {
                return _.chain(this.sid)
                    .thru(sid => {
                        return _.isArray(sid) ? sid : [sid]
                    })
                    .map(callback)
                    .filter()
                    .first()
                    .value()
            }
        }
    }
</script>
